var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-layout-full',{staticClass:"category-list",attrs:{"breadcrumb":_vm.breadcrumb},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Все каталоги")]},proxy:true}])},_vm._l((_vm.list),function(item){return _c('category',{key:`item-${item.id}`,staticClass:"category-list__item",attrs:{"category":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }